module.exports = __webpack_public_path__ + "assets/b28db67738c6b5919df0b6cfdac085ca.jpg";